import React from 'react';
import { StyledPartnershipRow } from './StyledPartnershipRow';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Autoplay]);

const PartnershipRow = ({ arrayPartners, title, categoryTitle, black}) => {
  return (
    <React.Fragment>
      {
       
          <StyledPartnershipRow
          >
            <div className="paragraph--col-wrap">
              <div className="paragraph--col-big">
                {
                  categoryTitle &&
                  <p className="preset-13">{categoryTitle}</p>
                }
                <h5 className="big--title" style={{color: black ? black : 'inherit'}}>
                  {title}
                </h5>
              </div>
            </div>
            <Swiper 
              slidesPerView={'auto'}
              spaceBetween={0}
              autoplay={{
                delay: 1500,
                disableOnInteraction: true
              }}
              
              onReachEnd={(swiper) => swiper.snapGrid = [...swiper.slidesGrid]}
              
              >
                {
                  arrayPartners.map((key, index) => {
                    
                    return  <SwiperSlide key={index}>
                              <img src={key} />
                            </SwiperSlide>
                  })
                  
                }
              </Swiper>
          </StyledPartnershipRow>
          
      }
    </React.Fragment>
  );
};

PartnershipRow.propTypes = {};

PartnershipRow.defaultProps = {
  arrayPartners: [
    require('../../assets/clients/NRF-client.png'),
    require('../../assets/clients/client-stella.png'),
    require('../../assets/clients/client-pepsico.png'),
    require('../../assets/clients/client-mondelez.png'),
    require('../../assets/clients/client-rana.png'),
    require('../../assets/clients/client-ipsos.png'),
    require('../../assets/clients/client-nestle.png'),
    require('../../assets/clients/client-ralphlauren.png')
  ],
  title: "See the brands that are already on board and trust in Invrsion",
  black: "#000"
};

export default PartnershipRow;
